/* eslint-disable complexity */
import { Divider, Stack, Typography } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { useEffect, useState } from 'react';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useParams } from 'react-router-dom';
import { getCompanyDashboard, getSelectedEntity } from 'state/reducers/customer-accounts.reducers';
import _ from 'lodash';

export const BeneficiaryPaymentScheme = () => {
	const t = useAppSelector(selectTranslations);
	const selectedEntity = useAppSelector(getSelectedEntity);
	const [schemeData, setSchemeData] = useState<any>(null);
	const fieldPrefix = 'page.customerAccounts.forms.beneficiaries.bankDetails.';

	useEffect(() => {
		if (selectedEntity?.data) {
			const { paymentSchemas } = selectedEntity?.data as any;
			setSchemeData(paymentSchemas);
		}
	}, [selectedEntity?.data]);

	return (
		<>
			{schemeData && (
				<Stack spacing={2}>
					{Object.keys(schemeData).map((schemeType: any, index: number) => {
						const type = schemeData[schemeType];
						return (
							<Stack key={index} spacing={3}>
								<Divider></Divider>
								<Stack direction="row" spacing={5}>
									<Typography variant="subtitle2">{t(`${fieldPrefix}${schemeType}`)}</Typography>
									{Object.keys(schemeData[schemeType]).length > 0 ? (
										<Stack spacing={1}>
											{Object.keys(type).map((item: any, index: number) => {
												return (
													<Stack key={index}>
														<Typography variant="subtitleBold">
															{t(fieldPrefix + item)}
															{/* {_.upperCase(_.snakeCase(item).replace('_', ' '))} */}
														</Typography>
														{type[item] ? (
															<Typography variant="subtitle2">{type[item]}</Typography>
														) : (
															<Typography variant="subtitle2">
																{t('label.noData')}
															</Typography>
														)}
													</Stack>
												);
											})}
										</Stack>
									) : (
										<Typography variant="subtitle2">{t('label.noData')}</Typography>
									)}
								</Stack>
							</Stack>
						);
					})}
				</Stack>
			)}
		</>
	);
};
